// extracted by mini-css-extract-plugin
export default {"wrapper":"HomeLayout_wrapper__AKSdI","container":"HomeLayout_container__sHzLC"};